import type { RouteRecordRaw } from 'vue-router'

export const routes: RouteRecordRaw[] = [
  {
    path: '/companies',
    name: 'companies',
    meta: {
      title: 'Companies'
    },
    component: () => import('@/views/companies/CompanyListView.vue')
  },
  {
    path: '/companies/create',
    name: 'company-create',
    meta: {
      title: 'Create Company'
    },
    component: () => import('@/views/companies/CompanyCreateView.vue')
  },
  {
    path: '/companies/:id',
    name: 'company-edit',
    props: true,
    meta: {
      title: 'Edit Company'
    },
    component: () => import('@/views/companies/CompanyEditView.vue'),
    children: [
      {
        path: '/companies/:id/f/:section',
        name: 'company-edit-section',
        props: true,
        meta: {
          title: 'Edit Company'
        },
        component: () => import('@/views/companies/CompanyEditView.vue')
      }
    ]
  }
]

export default routes
